import React, { useState } from "react";
import { useMask } from "@react-input/mask";
import { useMediaQuery } from "react-responsive";

const InputField = ({
  heading,
  isRequired,
  hintText,
  onChanged,
  errorMessage = "",
  mask = "",
  initialValue = "",
  big = false,
  minHeight = "",
  min = undefined,
  max = undefined,
  type = "",
  ...extraProps
}) => {
  const [currentValue, setCurrentValue] = useState("");
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const inputMask = useMask({
    mask: mask,
    replacement: { _: /\d/ },
  });
  const inputRef = mask == "" ? undefined : inputMask;
  return (
    <div style={styles.inputColumn}>
      <p style={styles.heading}>
        {heading}
        {isRequired && <span style={styles.required}> *</span>}
      </p>
      {big ? (
        <textarea
          {...extraProps}
          value={currentValue}
          onChange={(e) => {
            setCurrentValue(e.target.value);
            if (e.target.value == "") setCurrentValue(initialValue);
            onChanged(e.target.value);
          }}
          style={{
            ...styles.textInput,
            border: "1px solid var(--light-grey)",
            padding: "0.5rem",
            resize: "vertical",
            maxHeight: "25vh",
            minHeight: minHeight,
          }}
          placeholder={hintText}
          onFocus={(e) => {
            if (e.target.value == "") setCurrentValue(initialValue);
          }}
        />
      ) : mask != "" ? (
        <input
          {...extraProps}
          value={currentValue}
          onChange={(e) => {
            setCurrentValue(e.target.value);
            if (e.target.value == "") setCurrentValue(initialValue);
            onChanged(e.target.value);
          }}
          style={styles.textInput}
          placeholder={hintText}
          onFocus={(e) => {
            if (e.target.value == "") setCurrentValue(initialValue);
          }}
          type={type}
          ref={inputMask}
          min={min}
          max={max}
        />
      ) : (
        <input
          {...extraProps}
          value={currentValue}
          onChange={(e) => {
            setCurrentValue(e.target.value);
            onChanged(e.target.value);
          }}
          style={styles.textInput}
          placeholder={hintText}
          min={min}
          max={max}
          type={type}
        />
      )}
      {errorMessage && <p style={styles.errorMessage}>{errorMessage}</p>}
      <style>
        {`
          input::placeholder {
            color: var(--light-grey);
          }
        `}
      </style>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  inputColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    color: "var(--light-grey)",
  },
  heading: {
    fontSize: "var(--form-heading-font-size)",
    color: "var(--dark-grey)",
  },
  required: {
    color: "var(--orange)",
  },
  textInput: {
    fontSize: "var(--form-hint-text-font-size)",
    color: "var(--black)",
    border: "none",
    borderBottom: "1px solid var(--light-grey)",
    outline: "none",
    backgroundColor: "transparent",
    height: "2.5rem",
  },
  errorMessage: {
    color: "#FF0000",
    fontSize: "0.875rem",
    marginTop: "0.25rem",
  },
};

export default InputField;
